import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	wrapperStyles,
	labelStyles,
	inputStyles,
	errorStyles,
	optionalEditStyles,
	labelEditStyles,
	inputEditStyles,
	inputSizeStyles,
	inputSizeEditStyles,
} from '@/css/shared/inputs.css';

const getStyles = (formStyles) =>
	css(wrapperStyles(formStyles), inputSizeStyles(), {
		'.supt-inputTextarea__label': labelStyles(formStyles),
		'.supt-inputTextarea__input': cssObj(inputStyles(formStyles), {
			'.supt-inputTextarea__input': {
				resize: 'vertical',
			},
		}),
		'.supt-inputTextarea__error': errorStyles(formStyles),

		'&.supt-inputField--error': {
			'.supt-inputTextarea__input': {
				borderColor: formStyles.error?.color,
			},
		},
	});

// edit
const getEditStyles = (formStyles) =>
	css({
		'.supt-inputTextarea__optional': optionalEditStyles(formStyles),
		'.supt-inputTextarea__input': cssObj(inputEditStyles(formStyles), {
			minHeight: 'calc(1.5 * 1em * 4)' /* min 4 lines */,
		}),
		'.supt-inputTextarea__label': labelEditStyles(),
	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-textarea"]': inputSizeEditStyles(),
	});

export { getStyles, getEditStyles, getEditGlobalStyles };
